import React, { useEffect } from 'react';
import { ModuleWrapperProps } from '@/components/utilities/module-wrapper/module-wrapper';
import { useHotelContext } from '@/libraries/contexts/hotel-context/hotel-context';
import { usePageDetailsContext } from '@/libraries/contexts/page-details-context/page-details-context';
import InPageNavigationBar from './in-page-navigation-bar/in-page-navigation-bar';
import InPageNavigationFooter from './in-page-navigation-footer/in-page-navigation-footer';

export interface InPageNavigationProps extends ModuleWrapperProps {
  /** The anchor link id to scroll to configuration flow module */
  configurationFlowAnchorLinkId?: string;
  /** The links of the in-page navigation */
  links: Content.Properties.Link[];
  /** The search details of the in-page navigation */
  searchDetails?: Content.Components['HotelPageOfferDetailsDto'] | null;
}

const InPageNavigation = ({
  links = [],
  searchDetails,
  ...rest
}: InPageNavigationProps) => {
  const { totalPrice } = useHotelContext();
  const { configurationFlowAnchorLinkId, setSearchDetails, pageType } =
    usePageDetailsContext();

  useEffect(() => {
    if (!searchDetails) return;

    setSearchDetails(searchDetails);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [searchDetails]);

  return (
    <React.Fragment>
      <InPageNavigationBar {...rest} links={links} />

      {pageType === 'HotelPageDto' && totalPrice && (
        <InPageNavigationFooter
          {...rest}
          configurationFlowAnchorLinkId={configurationFlowAnchorLinkId}
          totalPrice={totalPrice}
        />
      )}
    </React.Fragment>
  );
};

InPageNavigation.displayName = 'InPageNavigation';

export default InPageNavigation;
